import { render } from "./CompanyDashboard.vue?vue&type=template&id=4c631913&ts=true"
import script from "./CompanyDashboard.vue?vue&type=script&lang=ts"
export * from "./CompanyDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__